export enum UserRole {
  admin = 'Administrador',
  partner = 'Sócios e Líderes',
  analyst = 'Analista',
}

export enum UserRoleColor {
  admin = 'purple',
  partner = 'pink',
  analyst = 'blue',
}

export type UserRoleType = keyof typeof UserRole;